<template>
    <v-layout wrap class="mx-3 mt-2">
      <v-flex xs12 sm4 v-for="project in videoProjects" v-bind:key="project._id" class="mt-2">
        <v-card class="pa-3">
              <video v-for="(video, index) in project.videos" v-bind:key="index" controls="" oncontextmenu="return false;" controlsList="nodownload" class="video-card"   
                  :src="`${host}/uploads/video_projects/video/${video}`" 
              ></video>
              <!-- <v-img
              :src="`${host}/uploads/video_projects/${project.videoCoverImage}`"
              class="project-img"></v-img> -->
              <h4>{{project.title}}</h4>              
              <div v-html="trimProjectText(project.description)"></div>
              <div v-if="project.active == true"><b>Project Status:</b> {{project.status}}</div>
              <div v-if="project.active == false"><b>Project Status:</b> <span style="color: red;"> Deactivated</span>, <a href="javascript:void(0)" @click="showContactModal" >Contact Support</a></div>
              <div><b>Category:</b> {{project.category}}</div>
              <div v-if="project.location"><b>Location:</b> {{project.location.locationName}}</div>
              <div v-else><b>Location:</b> N/A</div>
              <div><b>Posted On:</b> {{project.createdAt | moment("DD MMMM YYYY") }}</div>
          <v-card-actions>
            <v-btn icon :to="`/expert/video_project/details/${project._id}`">
              <v-icon color="green">visibility</v-icon> 
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon :to="`/expert/create/video_project?id=${project._id}`">
              <v-icon color="orange">edit</v-icon>
            </v-btn>
            <v-btn icon  @click="deleteModal(project)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <!-- report review modal -->
      <v-dialog v-model="reportModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Contact Support</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="reportModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <a :href="`https://wa.me/254777221441`" target="_blank">
                  <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
                </a>
              </v-flex>
              <v-flex xs12>
                  <span class="hidden-sm-and-down" style="color: #03a9f4"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</span><a class="hidden-md-and-up pl-2" href="tel:+254777221441"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- report review modal -->

      <!-- delete dialog -->
      <v-dialog v-model="deleteDialog" max-width="600px">
        <v-toolbar class="primary" dark dense>
          <v-toolbar-title>Delete project</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h3>Are you sure you want to delete this project?</h3>
            </v-flex>
            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteProject">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- end of delete  -->

    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { trimProjectText } from "@/common/methods.js";
export default {
  name: "ExpertProjectsList",
  props: {
    videoProjects: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  data() {
    return {
      reportModal: false,
      projectItem: {},
      deleteDialog: false,
    };
  },
  methods: {
    trimProjectText,
    showContactModal() {
      this.reportModal = true;
    },
    deleteModal(data) {
      this.projectItem = Object.assign({}, data);
      this.deleteDialog = true;
    },
    deleteProject(id) {
      const project = this.projectItem;
      const res = this.$store
        .dispatch("remove", "/videoproject/" + this.user._id + '/' + project._id)
        .then(res => {
          if(res.state) {
            location.reload();
          }
        });
    },
  }
};
</script>
<style scoped>
.video-card {
  width:100%;
  height:170px;
  border:1px solid #ccc;
  background-color: #000;
}
</style>